var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":false},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('div',{staticClass:"ShadowSlide"},[_c('img',{ref:"image",attrs:{"src":_vm.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }